import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Whether the counter under a limited text field shows: while the field has the focus, and
 *  while the text is over the limit, so the reason for the red ring stays in view after the
 *  field loses the focus. */
export function charCounterVisible(focused: boolean, length: number, max: number): boolean {
  return focused || length > max;
}

/**
 * "120/250" at the right end of a limited text field's title line (Description), in the type
 * of the Special Notes / Restrictions counter. On the title line rather than under the field,
 * so showing it never moves a row. Red past the limit, the same state that rings the field.
 *
 * Presentation only: the limit is the form's validator (createItemWriteForm), and the line
 * that explains a refusal is item-write-messages'.
 */
@Component({
  selector: 'app-char-counter',
  standalone: true,
  template: '<span class="char-counter" [class.__over]="over">{{ length }}/{{ max }}</span>',
  styleUrls: ['./char-counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CharCounterComponent {
  @Input() length = 0;
  @Input() max = 0;

  get over(): boolean {
    return this.length > this.max;
  }
}
